import { Component, Schema, type, defaultValue } from "minecs";
@Component()
export class AirportCash extends Schema {
    @type("number")
    @defaultValue(0)
    stage: number;
    @type("number")
    @defaultValue(-1)
    vending: number;
}
